module.exports = __webpack_public_path__ + "img/ESBE_0154.a14c2104.png";